/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive that shows an action link which consists of an icon and text.
 * For small displays, only the icon is displayed, and the text is a hover tooltip. For larger displays, both the
 * icon and the text are displayed, but there is no tooltip action.
 * The same text is used for the link text and the tooltip text.
 *
 * @example
 * This example initializes the scope to a list of names and
 * then uses `ngRepeat` to display every person:
  <label class="bulb-delete"
         bulb-action-link="'button_delete' | translate"
         ng-click="doSomething()"></label>
 *
 */
angular.module('bulbApp.utilsModule')

.directive('bulbActionLink', ['$compile', bulbActionLink]);

function bulbActionLink($compile) {
  return {
    restrict: 'A',
    link: function(scope, iElem, iAttrs) {

      // Add the tooltip if it doesn't exist
      if (iAttrs.tooltip === undefined) {
        iAttrs.$set('tooltip', '{{tooltip}}');
        iAttrs.$set('roll', 'button');
        $compile(iElem)(scope);
        return;
      }

      // Get the value of the directive, and evaluate it for the text to use"
      var value = iAttrs.bulbActionLink;
      scope.text = scope.$eval(value);

      // if value wasn't an expression, use it as a simple value
      if (scope.text === undefined) {
        scope.text = value;
      }

      // Only testing for small devices here, as medium devices should have room for both the icon and text.
      scope.$watch(function() { return Foundation.utils.is_small_only(); },  // jshint ignore:line
        function(isSmall) {
          if (isSmall) {
            scope.tooltip = scope.text;
            iElem.empty();
          } else {
            scope.tooltip = '';
            iElem.text(scope.text);
          }
        }
      );
    }
  };
}
